module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/demo9/bg-400-7b8ea83b9c6cd9c4c0f347c9448e7465.jpg";